<template>
  <v-dialog
      v-model="showForm"
      max-width="500px"
      transition="dialog-top-transition"
      persistent
  >
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>
          <h4 class="title">{{title}}</h4>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn
            icon
            dark
            @click="closed"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-form>
        <v-card-text>
          <div class="md-layout">
            <div >
              <v-text-field
                  v-model="group.name"
                  label="Nombre del Rol"
              />
              <v-autocomplete
                  v-model="permArr"
                  :items="perms"
                  item-text="name"
                  item-value="id"
                  label="Seleccionar los permisos"
                  multiple
                  chips
                  deletable-chips
                  small-chips
                  hint="Permisos del rol"
                  persistent-hint
              ></v-autocomplete>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="terciary" @click="closed">
            Cancelar
          </v-btn>
          <v-btn v-if="title==='Actualizar Rol'" color="secondary" @click="update" :loading="loading">
            Actualizar
          </v-btn>
          <v-btn v-else color="secondary" @click="create" :loading="loading">
            Crear
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: "GroupForm",
  props: {
    title: String,
    group: {},
    showForm: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters(['perms']),
  },
  data: ()=>({
    loading: false,
    permArr:[],
  }),
  mounted() {
    const list = this.group.permissions ? this.group.permissions.edges.map(d=> d.node) : [];
    console.log(list);
    this.permArr = list;
  },
  methods: {
    async create() {
      this.loading= true;
      this.group.permissions = this.permArr;
      await this.$store.dispatch('createGroup', this.group);
      this.loading= false;
      this.closed();
    },
    async update() {
      this.loading= true;
      this.group.permissions = this.permArr;
      await this.$store.dispatch('updateGroup', this.group);
      this.loading= false;
      this.closed();
    },
    closed() {
      this.$emit('close');
    },
  },
}
</script>

<style scoped>

</style>
